export default [
    {
        path: '/activities',
        name: 'activities-index',
        meta: {
            title: 'Activités'
        },
        component: () => import('~/views/activities/Index.vue'),
        redirect: { name: 'activities-form', params: { id: 'list' } },
        children: [
            {
                path: 'a/:id',
                name: 'activities-form',
                params: { id: 'list' },
                meta: { title: 'Liste des Activités' },
                component: () => import('~/views/activities/ActivityManager.vue')
            },
            {
                path: 'families',
                name: 'activity-families',
                meta: { title: 'Familles d\'activité' },
                component: () => import('~/views/activities/ActivityFamilyManager.vue')
            },
            {
                path: 'families/:id',
                name: 'activity-families-details',
                meta: { title: 'Détails de la famille d\'activité' },
                component: () => import('~/views/activities/ActivityFamilyEditManager.vue')
            },
            {
                path: 'sessions',
                name: 'sessions',
                meta: {
                    title: 'Sessions périodiques'
                },
                component: () => import('~/views/activities/Sessions.vue')
            },
            {
                path: 'sessions/new',
                name: 'activities-sessions-new',
                meta: {
                    title: 'Création d\'une session'
                },
                component: () => import('~/components/sessions/show/SessionNew.vue')
            },
            {
                path: 'sessions/:id',
                name: 'activities-sessions-show',
                meta: {
                    title: 'Détails de la session périodique'
                },
                component: () => import('~/components/sessions/SessionShow.vue')
            },
            {
                path: 'registrations',
                name: 'registrations',
                meta: {
                    title: 'Inscriptions périodiques'
                },
                component: () => import('~/components/sessions/Registrations.vue')
            },
            {
                path: 'registrations/new',
                name: 'registrations-new',
                meta: {
                    title: 'Création d\'une inscription périodique'
                },
                component: () => import('~/components/sessions/RegistrationEdit.vue')
            },
            {
                path: 'registrations/:id',
                name: 'registrations-edit',
                meta: {
                    title: 'Modification d\'une inscription périodique'
                },
                component: () => import('~/components/sessions/RegistrationEdit.vue')
            },
            {
                path: 'phases',
                name: 'phases',
                meta: {
                    title: 'Phases d\'inscriptions'
                },
                component: () => import('~/views/activities/Phases.vue')
            },
            {
                path: 'phases/new',
                name: 'phases-new',
                meta: {
                    title: 'Création d\'une phase'
                },
                component: () => import('~/components/sessions/PhaseEdit.vue')
            },
            {
                path: 'phases/:id',
                name: 'phases-show',
                meta: {
                    title: 'Phases'
                },
                component: () => import('~/components/sessions/PhaseEdit.vue')
            },
            {
                path: 'cashregister/new',
                name: 'cashregister-new',
                meta: {
                    title: 'Création d\'une inscription périodique depuis la caisse',
                    disableDashboardLayout: true
                },
                component: () => import('~/components/sessions/RegistrationEdit.vue')
            }
        ]
    }
]
